import { Dialog } from "@headlessui/react"
import React, { useEffect, useState } from "react"

interface MediaPlayerProps {
  youtubeId?: string
  spotifyId?: string
}

const MediaPlayerComponent: React.FC<MediaPlayerProps> = ({ youtubeId, spotifyId }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (youtubeId || spotifyId) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [youtubeId, spotifyId])

  const onClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={() => onClose()} className="relative z-50">
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        {youtubeId && (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
            title="YouTube Video Player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}

        {spotifyId && (
          <iframe
            src={`https://open.spotify.com/embed/track/${spotifyId}?autoplay=true`}
            width="500"
            height="80"
            allow="encrypted-media"
          ></iframe>
        )}
      </div>
    </Dialog>
  )
}

export default MediaPlayerComponent
